import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import * as Sentry from '@sentry/react';

import { store } from './app/store';
import App from './App';
import './index.css';
import { isUatEnvironment } from './utils/requestUtils';

const env = process.env.REACT_APP_ENV;
if (env === 'production' && !isUatEnvironment()) {
  Sentry.init({
    dsn: 'https://7cebe5420a604b51925ca56c6e50cf15@sentry.ktback.cloud/19',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.5,
  });
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container missing in index.html');
}
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <div><Toaster /></div>
      <App />
    </Provider>
  </React.StrictMode>
  ,
);
